import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "reports-leads"
}
const _hoisted_3 = { class: "reports-container-horizontal-bar-chart" }
const _hoisted_4 = {
  key: 0,
  class: "bar-chart-horizontal"
}
const _hoisted_5 = {
  key: 1,
  class: "reports-by-number"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($setup.leadsByEstate && $setup.props.role !== 'landowner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode($setup["ChartForReports"], {
                  labels: $setup.leadsByEstate.source,
                  setData: $setup.leadsByEstate.quantity,
                  backgroundColor: $setup.chartBackgroundColor,
                  title: 'New Leads',
                  chartType: 'bar',
                  options: $setup.optionsForHorizontalBarchart
                }, null, 8, ["labels", "setData", "backgroundColor", "options"])
              ]))
            : _createCommentVNode("", true),
          ($setup.leadsByEstate && $setup.props.role === 'landowner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode($setup["ReportsByNumber"], {
                  title: 'New Leads',
                  number: $setup.leadsByEstate.total
                }, null, 8, ["number"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}